export default "__VITE_ASSET__CPYSgplk__"